import React from 'react'
import Manager from 'tyan/public/components/Manager'
import OperationRuleDetail from './OperationRuleDetail'
import InstrumentDetail from '../InstrumentDetail'

Ext.require('Ext.Toast')

const config = {
    buttons: [
    ],
    export: true,
    exportColumns: [
        { _text: '申请编号', field: 'Number', minWidth: 150, locked: false, search: true, },
        { _text: '版本号', field: 'Edition', minWidth: 150, flex: 1, search: true, },
        { _text: '设备编号', field: 'InstrumentNumber', minWidth: 150, flex: 1, search: true, },
        { _text: '设备名称', field: 'InstrumentName', minWidth: 150, flex: 2, search: true, },
        { _text: '型号', field: 'InstrumentModel', minWidth: 150, flex: 1, filter: true, },
        { _text: '申请人', field: 'Creator', minWidth: 120, filter: true, },
        { _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, },
        { _text: '状态名称', field: 'StatusName', minWidth: 120, filter: true, },
    ],
    columns: [
        { _text: '申请编号', field: 'Number', minWidth: 150, locked: false, search: true, },
        { _text: '版本号', field: 'Edition', minWidth: 150, flex: 1, search: true, },
        {
            _text: '设备编号', field: 'InstrumentNumber', minWidth: 150, flex: 1, search: true,
            tools: [{
                _tool: '', btnName: '查_看2', zone: 'end',
                handler: ({ showDetail, refreshPage }, data) => { showDetail(props => <InstrumentDetail {...props} id={data.InstrumentID} readOnly={true} />) }
            }]
        },
        { _text: '设备名称', field: 'InstrumentName', minWidth: 150, flex: 2, search: true, },
        { _text: '型号', field: 'InstrumentModel', minWidth: 150, flex: 1, filter: true, },
        { _text: '申请人', field: 'Creator', minWidth: 120, filter: true, },
        { _date: '申请日期', field: 'CreateTime', minWidth: 150, filter: true, },
        { _text: '状态名称', field: 'StatusName', minWidth: 120, filter: true, },
        { _: '', name: 'InstrumentID', field: 'InstrumentID' },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => showDetail(props => <OperationRuleDetail {...props} id={data.id} readOnly={true} />),
}

export default props => <Manager {...props} config={config} />